import styled from "styled-components";

const ButtonContainer = styled.button`
  padding: ${(props) => props.padding || "4px 16px"};
  width: fit-content;
  background-color: ${(props) =>
    props.background && props.background + "!important"};
  background-color: ${({ theme }) => theme.colors.grey};
  border: none;
  border-radius: 30px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black};

  &:hover:not(:disabled) {
    background-color: ${(props) =>
      props.background && props.background + "!important"};
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
  }

  &:disabled {
    cursor: default;
  }
`;

export default ButtonContainer;
